import { createSlice } from '@reduxjs/toolkit';

/**
 * Genera 3 timestamps aleatorios distribuidos en las 8 horas del turno.
 * Los checks se reparten en 3 ventanas de ~2.5h para garantizar buena distribución.
 * No se programan en los primeros 30 min ni los últimos 30 min del turno.
 *
 * @param {number} loginTime - timestamp ms del inicio de sesión
 * @returns {number[]} array de 3 timestamps ordenados ascendentemente
 */
function generateCheckTimes(loginTime) {
  const SHIFT_MS = 8 * 60 * 60 * 1000; // 8 horas en ms
  const BUFFER = 30 * 60 * 1000;       // 30 min de buffer al inicio y fin
  const usable = SHIFT_MS - 2 * BUFFER; // ventana útil: 7 horas
  const windowSize = usable / 3;        // cada ventana: ~2.33 horas

  const times = [];
  for (let i = 0; i < 3; i++) {
    const windowStart = BUFFER + i * windowSize;
    const windowEnd = windowStart + windowSize;
    const offset = windowStart + Math.random() * (windowEnd - windowStart);
    times.push(Math.floor(loginTime + offset));
  }
  return times.sort((a, b) => a - b);
}

const faceCheckSlice = createSlice({
  name: 'faceCheck',
  initialState: {
    scheduledChecks: [],   // [timestamp, timestamp, timestamp]
    completedChecks: [],   // índices (0,1,2) de checks completados exitosamente
    activeCheckIndex: null, // índice del check que se está mostrando ahora (0,1,2)
    locked: false,          // sesión bloqueada por fallo en check
  },
  reducers: {
    initChecks: (state, action) => {
      const loginTime = action.payload || Date.now();
      state.scheduledChecks = generateCheckTimes(loginTime);
      state.completedChecks = [];
      state.activeCheckIndex = null;
      state.locked = false;
    },
    triggerCheck: (state, action) => {
      state.activeCheckIndex = action.payload; // índice 0, 1, o 2
    },
    completeCheck: (state, action) => {
      const index = action.payload;
      if (!state.completedChecks.includes(index)) {
        state.completedChecks.push(index);
      }
      state.activeCheckIndex = null;
    },
    failCheck: (state) => {
      state.activeCheckIndex = null;
      state.locked = true;
    },
    unlockSession: (state) => {
      // El coordinador volvió a iniciar sesión — desbloquear pero mantener checks completados
      state.locked = false;
      state.activeCheckIndex = null;
    },
    clearFaceCheck: (state) => {
      state.scheduledChecks = [];
      state.completedChecks = [];
      state.activeCheckIndex = null;
      state.locked = false;
    },
  },
});

export const {
  initChecks,
  triggerCheck,
  completeCheck,
  failCheck,
  unlockSession,
  clearFaceCheck,
} = faceCheckSlice.actions;

export default faceCheckSlice.reducer;
